import { AsyncComponent } from '@frontend/components/common';
import { Route } from 'react-router-dom';

import InsightDetail from './insights/insight-detail/insight-detail.component';
import InsightsOverview from './insights/insights.component';
import ReportsOverview from './report-overview/report-overview.component';
import { Schedules } from './schedule/schedule.component';

export function ApplicationsAnalyticsRoutes() {
    return (
        <Route path='analytics'>
            <Route path='reports'>
                <Route
                    index
                    element={
                        <AsyncComponent>
                            <ReportsOverview />
                        </AsyncComponent>
                    }
                />
            </Route>
            <Route path='insights'>
                <Route
                    index
                    element={
                        <AsyncComponent>
                            <InsightsOverview />
                        </AsyncComponent>
                    }
                />
                <Route
                    path=':insightId/detail'
                    element={
                        <AsyncComponent>
                            <InsightDetail />
                        </AsyncComponent>
                    }
                />
            </Route>
            <Route path='schedules'>
                <Route
                    index
                    element={
                        <AsyncComponent>
                            <Schedules />
                        </AsyncComponent>
                    }
                />
            </Route>
        </Route>
    );
}
